import { Injectable } from '@angular/core';

export class Data {
  text: string;
  priorityId: number;
  typeId: number;
  startDate: Date;
  endDate: Date;
  recurrenceRule?: string;
}

export class PriorityData {
  text: string;
  id: number;
  color: string;
}

export class TypeData {
  text: string;
  id: number;
  color: string;
}

export class Task {
    id: number;
    parentId: number;
    title: string;
    start: Date;
    end: Date;
    progress: number;
}

export class Dependency {
    id: number;
    predecessorId: number;
    successorId: number;
    type: number;
}

export class Resource {
    id: number;
    text: string;
}

export class ResourceAssignment {
    id: number;
    taskId: number;
    resourceId: number;
}

export class Appointment {
  text: string;
  priorityId: number;
  startDate: Date;
  endDate: Date;
}

export class Priority {
  text: string;
  id: number;
  color: string;
}

export class TaskStatus {
  name: string;
  id: number;
}

export class Project {
  text: string;
  id: number;
  color: string;
}

export class Category {
  text: string;
  id: number;
  color: string;
}

let data: Data[] = [];

let priorityData: PriorityData[] = [{
  text: "Low Priority",
  id: 1,
  color: "#fcb65e"
}, {
  text: "High Priority",
  id: 2,
  color: "#e18e92"
}
];

let typeData: TypeData[] = [];

let appointments: Appointment[] = [];

let prioritiesData: Priority[] = [];

let resources: any = [];

let tasks: Task[] = [];

let dependencies: Dependency[] = [];

let resources2: Resource[] = [];

let resourceAssignments: ResourceAssignment[] = [];

@Injectable()
export class Service {
  getPriorityData() {
    return priorityData;
  }
  getTypeData() {
    return typeData;
  }
  getData() {
    return data;
  }

  getAppointments() {
    return appointments;
  }
  getPriorities() {
    return prioritiesData;
  }

  getResources(): any {
    return resources;
  }

  getTasks(): Task[] {
      return tasks;
  }
  getDependencies(): Dependency[] {
      return dependencies;
  }
  getResources2(): Resource[] {
      return resources2;
  }
  getResourceAssignments(): ResourceAssignment[] {
      return resourceAssignments;
  }

}
